import { render, staticRenderFns } from "./ConfiguracionReporte.vue?vue&type=template&id=0316cd83"
import script from "./ConfiguracionReporte.vue?vue&type=script&lang=js"
export * from "./ConfiguracionReporte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports